import styled from "@emotion/styled";
import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const DrawerTitlesContainer = styled.div`
  display: flex;
  background: ${theme.gradient.themeGradient};
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 20px;
  height: 50px;
`;

const CloseIcon = styled.p`
  cursor: pointer;
  color: white;
`;

const DrawerTitles = styled.span`
  font-size: 17px;
  color: white;
  font-weight: normal;
`;

const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 40%;
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 10px;
  color: #afafaf;
  font-size: 20px;
`;

const InputStyle = styled.input`
  width: 100%;
  height: 30px;
  padding: 8px 8px 8px 35px;
  font-size: 13px;
  border: 1px solid #eb7909;
  border-radius: 5px;
  &:focus {
    outline: none;
    border-color: #ccc;
  }
  ,
  &::placeholder {
    color: #afafaf;
  }
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const SC = {
  DrawerTitlesContainer,
  CloseIcon,
  DrawerTitles,
  InputContiner,
  SearchIcon,
  InputStyle,
  ButtonContainer,
};

export default SC;
